<template>
	<el-col :span="16">
		<el-card class="goods-info goods-item">
			<h3>{{ info.standardCode }}&nbsp;&nbsp;{{ info.standardName }}</h3>

			<div class="flexStart" style="align-items: baseline;">
				<div class="tags">
					<el-tag v-if="info.standardIndustry.length > 0">特种设备</el-tag>
					<el-tag type="success" v-if="getStandardTypeName(info.standardTypeId)">{{ getStandardTypeName(info.standardTypeId) }}</el-tag>
					<!-- <el-tag type="danger" v-if="info.lifeName">{{ info.lifeName }}</el-tag> -->

					<!-- <div class="tagbg tagorange" v-if="info.isRead !== null && info.isRead !== undefined">{{ info.isRead === 0 ? '纸质版购买' : info.isRead === 1 ? '电子版购买' : '' }}</div> -->
					<!-- <div class="tagbg tagorange" v-if="info.pdfRead !== null">{{ info.pdfRead == 0 ? 'PDF 公开文件' : info.pdfRead == 1 ? 'PDF VIP阅读' : info.pdfRead == 2 ? 'PDF 购买后可阅读' : '' }}</div> -->

					<div class="tagbg tagorange" v-if="info.buyPaper">{{ info.buyPaper ? '纸质版可购' : '' }}</div>
					<div class="tagbg tagorange" v-if="info.buyPdf">{{ info.buyPdf ? '电子版可购' : '' }}</div>
					<!-- <div  class="tagbg tagorange" v-if="info.buyJson ">{{ info.buyJson?'智能文档可购':'' }}</div> -->
					<div class="tagbg tagorange" v-if="info.isPdf !== 0">{{ info.pdfRead == 0 ? 'PDF 公开文件' : info.pdfRead == 1 ? 'PDF VIP阅读' : info.pdfRead == 2 ? 'PDF 购买后可阅读' : '' }}</div>
					<div class="tagbg tagorange" v-if="info.isJson !== 0">{{ info.jsonRead == 0 ? '智能文档 公开文件' : info.jsonRead == 1 ? '智能文档 VIP阅读' : info.jsonRead == 2 ? '智能文档 购买后可阅读' : '' }}</div>
					<div class="tagbg tagorange" v-if="info.isAi !== 0">{{ info.isAi ? 'AI 收录' : '' }}</div>

					<!-- <el-tag type="danger">{{ info.status }}</el-tag> -->
					<!-- <el-tag type="warning">2022年发布</el-tag> -->
				</div>
				<div style="flex-shrink: 0; white-space: nowrap; display: flex;  gap: 6px;">
				<div class="view-box flexStart">
					<span v-if="info.visitNum"
						><i class="el-icon-view"></i><em>查看{{ info.visitNum }}次</em></span
					>
					<span v-if="info.buyNum"
						><i class="el-icon-shopping-cart-1"></i><em>已售{{ info.buyNum }}本</em></span
					>
				</div>
				
				<div class="flexStart">
					<el-tag v-if="getLifeName(info.lifeId)" :type="getLifeTagType(info.lifeId)" style="" effect="dark" class="life-tag">
						{{ getLifeName(info.lifeId) }}
					</el-tag>
					<!-- <span class="flexStart view-box" style="cursor: pointer; gap: 0; color: #333" @click="handleCollect" v-click-once>
						<i style="margin-right: 0" :class="info.isCollect ? 'el-icon-star-on icon-collect-on' : 'el-icon-star-on icon-collect-off'"></i
						><em :style="{ color: info.isCollect ? '#E6A23C' : 'inherit' }">{{ info.isCollect ? '已收藏' : '收藏' }}</em></span
					> -->
				</div>
			</div>
		</div>

			<div style="margin-top: 20px;">
				<div class="tags flex" v-if="standardCategoryInfo.length">
					<span style="font-size: 13px;">设备类型：</span>
					<div style="flex: 1">
						<el-tag style="margin-right: 14px; margin-bottom: 8px" type="info" v-for="(item, idx) in standardCategoryInfo" :key="idx">{{ item.categoryName }}</el-tag>
					</div>
				</div>
				<div class="tags flex" v-if="standardLifeLabelInfo.length" style="padding-top: 10px">
					<span style="font-size: 13px;">生命周期：</span>
					<div style="flex: 1">
						<el-tag style="margin-right: 14px; margin-bottom: 6px" type="info" v-for="(item, idx) in standardLifeLabelInfo" :key="idx">{{ item.labelName }}</el-tag>
					</div>
				</div>
				<div class="tags flex" v-if="standardMajorLabelInfo.length" style="padding-top:  10px">
					<span style="font-size: 13px;">专业领域：</span>
					<div style="flex: 1">
						<el-tag style="margin-right: 14px; margin-bottom: 6px" type="info" v-for="(item, idx) in standardMajorLabelInfo" :key="idx">{{ item.labelName }}</el-tag>
					</div>
				</div>
			</div>

			<el-divider></el-divider>

			<div class="infobox" v-if="filteredFieldNames.length > 0">
				<dl v-for="field in filteredFieldNames" :key="field.showField">
					<dt>{{ field.showName }}:</dt>
					<dd v-if="info[field.showField]" :title="info[field.showField]">{{ info[field.showField] }}</dd>
					<dd v-else class="empty-text">暂无</dd>
				</dl>
			</div>
			<div class="infobox" v-if="filteredFieldNames.length == 0">
				<el-empty description="暂无文件信息"></el-empty>
			</div>
		</el-card>

		<el-card class="goods-desc goods-item" v-if="info.standardSummary || info.standardScope">
			<h4>内容简介</h4>
			<div class="gcontent">
				<!-- <span v-if="!info.standardSummary" class="nullcolor">
					<el-empty description="暂无内容简介"></el-empty>
				</span> -->
				<div v-if="info.standardSummary" v-html="info.standardSummary" class="goos-summary"></div>
				<div v-if="!info.standardSummary && info.standardScope" v-html="info.standardScope" class="goos-summary"></div>
				<!-- <p>本标准规定了质量管理体系要求，适用于任何组织，无论其规模或所提供的产品和服务类型。本标准旨在通过满足顾客要求和适用的法律法规要求，增强顾客满意。</p>
            <p>本标准可被组织用于内部和外部(包括认证机构)评价组织满足顾客要求、适用的法律法规要求和组织自身要求的能力。</p>
            <p>本标准的实施不应增加或改变组织的法律责任。</p> -->
			</div>
		</el-card>

		<el-card class="goods-nulu goods-item" v-if="treeData.length">
			<div class="catalog-header flexBetween">
				<h4>目录预览</h4>
				<el-button type="text" @click="toggleCatalog" :icon="expandedKeys.length > 0 ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" class="expand-btn">
					{{ expandedKeys.length > 0 ? '折叠' : '展开' }}
				</el-button>
			</div>
			<div class="gmulu" :class="{ 'catalog-collapsed': expandedKeys.length > 0 }">
				<!-- {{ isCatalogExpanded }}---{{ expandedKeys }} -->
				<div v-loading="loading" class="doctree" element-loading-spinner="el-icon-loading" element-loading-text="目录加载中...">
					<el-tree ref="tree" :data="treeData" node-key="clauseId" :default-expanded-keys="expandedKeys" :props="defaultProps" :key="treeKey">
						<template #default="{ node, data }">
							<div class="tree-node-content">
								<!-- v-html 有 data.number 就拼接，没有就不拼接 -->
								<div class="aside-item" :title="getNodeTitle(data, node)" v-html="getNodeDisplayText(data, node)"></div>
							</div>
						</template>
					</el-tree>
				</div>
			</div>
		</el-card>

		<!-- {{ isMainFile }} ---{{ mainFile }} -->

		<el-card class="goods-desc goods-item" v-if="isMainFile">
			<h4>出版信息</h4>
			<div class="gcontent">
				<el-row>
					<el-col :span="12">
						<div class="agency-item flexStart">
							<label>出版社：</label>
							<div>
								<h6 v-if="mainFile.skuInfo.otherName" class="agency-title">{{ mainFile.skuInfo.otherName }}</h6>
								<h6 v-else class="empty-text agency-title" style="font-size: 13px">暂无</h6>
							</div>
						</div>
					</el-col>
					<el-col :span="12">
						<div class="agency-item flexStart">
							<label>书号：</label>
							<div>
								<h6 v-if="mainFile.skuInfo.barCode" class="agency-title">{{ mainFile.skuInfo.barCode }}</h6>
								<h6 v-else class="empty-text agency-title" style="font-size: 13px">暂无</h6>
							</div>
						</div>
					</el-col>
					<el-col :span="12">
						<div class="agency-item flexStart">
							<label>版次：</label>
							<div>
								<h6 v-if="mainFile.skuInfo.releaseVersion" class="agency-title">{{ mainFile.skuInfo.releaseVersion }}</h6>
								<h6 v-else class="empty-text agency-title" style="font-size: 13px">暂无</h6>
							</div>
						</div>
					</el-col>
					<el-col :span="12">
						<div class="agency-item flexStart">
							<label>开页：</label>
							<div>
								<h6 v-if="mainFile.skuInfo.trimSize" class="agency-title">{{ mainFile.skuInfo.trimSize }}</h6>
								<h6 v-else class="empty-text agency-title" style="font-size: 13px">暂无</h6>
							</div>
						</div>
					</el-col>
					<el-col :span="12">
						<div class="agency-item flexStart">
							<label>印张：</label>
							<div>
								<h6 v-if="mainFile.skuInfo.pageCount" class="agency-title">{{ mainFile.skuInfo.pageCount }}</h6>
								<h6 v-else class="empty-text agency-title" style="font-size: 13px">暂无</h6>
							</div>
						</div>
					</el-col>
					<el-col :span="12">
						<div class="agency-item flexStart">
							<label>字数：</label>
							<div>
								<h6 v-if="mainFile.skuInfo.wordCount" class="agency-title">{{ mainFile.skuInfo.wordCount }}</h6>
								<h6 v-else class="empty-text agency-title" style="font-size: 13px">暂无</h6>
							</div>
						</div>
					</el-col>
					<el-col :span="12">
						<div class="agency-item flexStart">
							<label>定价：</label>
							<div>
								<h6 v-if="mainFile.skuInfo.fixedPrice" class="agency-title">{{ mainFile.skuInfo.fixedPrice }}元</h6>
								<h6 v-else class="empty-text agency-title" style="font-size: 13px">暂无</h6>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</el-card>

		<el-card class="goods-desc goods-item" v-if="standardHistoryList.length > 0">
			<h4>文件历史</h4>
			<div class="gcontent">
				<div style="width: 100%">
					<el-timeline class="timeline" ref="timeline">
						<el-timeline-item class="lineitem" :color="activity.color" v-for="(activity, index) in standardHistoryList" :key="index">
							<span style="display: flex; flex-direction: column">
								<span style="margin: 10px 0; font-size: 14px">
									{{ activity.historyName }}
								</span>
								<span style="color: #8c8c8c; font-size: 12px">
									{{ activity.historyDate }}
								</span>
							</span>
						</el-timeline-item>
					</el-timeline>
					<div class="flexBetween" style="align-items: baseline">
						<div style="margin-top: 20px; margin-right: 20px">
							<div v-if="replaceFiles.length > 0" class="flexStart" style="flex-wrap: wrap">
								<ReplaceStandardCard
									style="margin-right: 20px; margin-bottom: 20px"
									v-for="(item, index) in replaceFiles"
									:key="index"
									:info="item"
									title="代替了以下标准"
									type="danger"
								></ReplaceStandardCard>
							</div>
						</div>
						<div style="margin-top: 20px">
							<div v-if="replacedFiles.length > 0" class="flexStart" style="flex-wrap: wrap">
								<ReplacedStandardCard
									style="margin-right: 20px; margin-bottom: 20px"
									v-for="(item, index) in replacedFiles"
									:key="index"
									:info="item"
									title="被以下标准代替"
									type="success"
								></ReplacedStandardCard>
							</div>
						</div>
					</div>
				</div>

				<!-- <div class="flex" style="padding: 0 20px 12px">
					<ReplaceStandardCard :info="replaceFiles[0]" title="代替了以下标准" type="danger"></ReplaceStandardCard>
					<ReplaceStandardCard :info="replacedFiles[0]" title="被以下标准代替" type="success"></ReplaceStandardCard>
				</div> -->
			</div>
		</el-card>

		<el-card class="goods-desc goods-item" v-if="draftAgencyMajor.length > 0">
			<h4>起草单位</h4>
			<div class="gcontent">
				<el-row>
					<el-col :span="12" v-for="(item, index) in draftAgencyMajor" :key="index">
						<div class="agency-item flexStart">
							<i class="el-icon-price-tag"></i>
							<h6 class="agency-title">{{ item }}</h6>
						</div>
					</el-col>
				</el-row>
			</div>
		</el-card>

		<el-card class="goods-desc goods-item" v-if="draftPersonMajor.length > 0">
			<h4>起草人</h4>
			<div class="gcontent">
				<el-row>
					<el-col :span="6" v-for="(item, index) in draftPersonMajor" :key="index">
						<div class="agency-item flexStart">
							<i class="el-icon-user"></i>
							<h6 class="agency-title">{{ item }}</h6>
						</div>
					</el-col>
				</el-row>
			</div>
		</el-card>

		<el-card class="goods-desc goods-item" v-if="referenceFiles.length > 0">
			<h4>引用文件</h4>
			<div class="gcontent">
				<el-row>
					<el-col :span="8" v-for="(item, index) in referenceFiles" :key="index">
						<div v-if="item.quoteId" class="agency-item flexStart isLink" @click="handleClick(item.quoteId)" :title="item.quoteCode + ' ' + item.quoteName">
							<i class="el-icon-link"></i>
							<h6 class="agency-title">{{ item.quoteCode }}</h6>
						</div>
						<div v-else class="agency-item flexStart" :title="item.quoteCode">
							<i class="el-icon-link"></i>
							<h6 class="agency-title">{{ item.quoteCode }}</h6>
						</div>
					</el-col>
				</el-row>
			</div>
		</el-card>

		<!-- <el-card class="goods-desc goods-item" v-if="adoptFiles.length > 0">
			<h4>采用文件</h4>
			<div class="gcontent">
				<el-row>
					<el-col :span="24" v-for="(item, index) in adoptFiles" :key="index">
						<div class="agency-item flexStart isLink" @click="handleClick(item.quoteId)">
							<i class="el-icon-link"></i>
							<h6 class="agency-title">{{ item.quoteCode }} {{ item.quoteName }}</h6>
						</div>
					</el-col>
				</el-row>
			</div>
		</el-card>

		<el-card class="goods-desc goods-item" v-if="replaceFiles.length > 0">
			<h4>替代文件</h4>
			<div class="gcontent">
				<el-row>
					<el-col :span="24" v-for="(item, index) in replaceFiles" :key="index">
						<div class="agency-item flexStart isLink" @click="handleClick(item.replaceId)">
							<i class="el-icon-link"></i>
							<h6 class="agency-title">{{ item.replaceCode }} {{ item.replaceName }}</h6>
						</div>
					</el-col>
				</el-row>
			</div>
		</el-card> -->

		<!-- <el-card class="goods-comment goods-item">
			<h4>相关讨论</h4>
			<div :class="{ boxopened: isCommentOpen }" class="clist">
				<template v-if="ajax_data_com.total > 0">
					<div v-for="(info, index) in commList" :key="'for_book_' + info.id" :class="{ isopened: index < displayNum || isCommentOpen }" class="ccard">
						<h4>{{ info.title }}</h4>
						<div class="c-content">{{ info.content }}</div>
						<div class="c-foot flexBetween">
							<el-col class="flexStart">
								<el-avatar :src="info.createUserAvatar" size="small"></el-avatar>
								<span>{{ info.createUserName }}</span>
								<span>{{ info.createTime }}</span>
							</el-col>
							<el-col class="tr">
								<el-link href="https://element.eleme.io" style="display: none">
									<i class="el-icon-chat-dot-round"></i>
									19条评论
								</el-link>
							</el-col>
						</div>
					</div>

					<div :class="{ pageopened: isCommentOpen || commList.length <= displayNum }" class="pagebox">
						<el-pagination
							:current-page.sync="ajax_data_com.pageNum"
							:page-size.sync="ajax_data_com.pageSize"
							:total="ajax_data_com.total"
							background
							layout="prev, pager, next"
							@current-change="onPage"
						></el-pagination>
					</div>
				</template>
				<div v-else class="emptybox">
					<el-empty description="暂无讨论"></el-empty>
				</div>
				<div v-show="commList.length > displayNum && !isCommentOpen" slot="footer" class="card-foot tc clearfix">
					<button class="btn is-plain is-round" type="button" @click="openReadMore">
						<span>查看全部评论</span>
					</button>
				</div>
			</div>
		</el-card>

		<el-card class="goods-nulu goods-item">
			<h4>相关标准推荐</h4>
			<div class="gmulu">
				<div class="emptybox">
					<el-empty description="暂无标准推荐"></el-empty>
				</div>
			</div>
		</el-card> -->
	</el-col>
</template>

<script>
import 'katex/dist/katex.min.css';
import EReg from '@/utils/EReg';
import { getFilesDocmentCatalogDet } from '@/api/standards/doc';
import { postMemberBookCollect } from '@/api/book/book';
import { getStandardDetRemoveCollect, getReplacedStandardDet, getStandardHistoryDet, getQuoteStandardDet, getAdoptStandardDet, getReplaceStandardDet } from '@/api/standards/det';
import TMessage from '@/utils/TMessage';
import { mapActions, mapGetters } from 'vuex';
import ReplaceStandardCard from '@/views/StandardsView/components/ReplaceStandardCard.vue';
import ReplacedStandardCard from '@/views/StandardsView/components/ReplacedStandardCard.vue';
export default {
	props: {
		info: {
			type: Object,
			default: {}
		},
		lifeList: {
			type: Array,
			default: () => []
		},
		standardTypeList: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			activities: [
				{
					content: '征求意见稿',
					timestamp: '2018-04-13',
					active: true
				},

				{
					content: '即将实施',
					timestamp: '2018-04-11',
					active: true
				},
				{
					content: '现行',
					timestamp: '2018-04-11',
					active: true
				},
				{
					content: '有更新版',
					timestamp: '2018-04-11',
					active: true
				},
				{
					content: '有更新版',
					timestamp: '2018-04-11',
					active: true
				}
			],
			ajax_data_com: {
				docmentId: '',
				pageNum: 1,
				pageSize: 10,
				total: 0
			},
			isCommentOpen: false,
			displayNum: 2,
			commList: [],

			isOpen: true,
			gmulu: [],
			defaultProps: {
				children: 'children',
				label: 'title'
			},
			treeData: [],
			loading: false,

			//标准历史节点信息
			standardHistoryList: [],

			//引用文件
			referenceFiles: [],

			//采用文件
			adoptFiles: [],

			//替代文件
			replaceFiles: [],
			replacedFiles: [],

			//主文件商品信息
			mainFile: null,

			//目录展开状态
			isCatalogExpanded: false,
			//目录展开的节点key
			expandedKeys: [],
			treeKey: 0,

		
		};
	},
	components: { ReplaceStandardCard, ReplacedStandardCard },
	watch: {
		// 监听标准历史列表变化，自动滚动到最右侧
		standardHistoryList: {
			handler(newVal) {
				if (newVal && newVal.length > 0) {
					this.$nextTick(() => {
						this.scrollTimelineToEnd();
					});
				}
			},
			immediate: true
		}
	},
	computed: {
		// 过滤出当前标准类型的字段
		filteredFieldNames() {
			return this.info.fieldNames;
		},
		draftAgencyMajor() {
			//this.info.draftAgencyMajor 字符串 如果不为空，以、隔开 返回数组
			if (this.info.draftAgencyMajor && this.info.draftAgencyMajor.length > 0) {
				return this.info.draftAgencyMajor.split('、');
			} else {
				return [];
			}
		},
		draftPersonMajor() {
			//this.info.draftPersonMajor 字符串 如果不为空，以、隔开 返回数组
			if (this.info.draftPersonMajor && this.info.draftPersonMajor.length > 0) {
				return this.info.draftPersonMajor.split('、');
			} else {
				return [];
			}
		},
		standardCategoryInfo() {
			if (this.info.standardCategory && this.info.standardCategory.length > 0) {
				return this.convertTreeDataToTreeArr(this.info.standardCategory, 'categoryName', 'categoryId', 'parentCategory');
			} else {
				return [];
			}
		},

		standardLifeLabelInfo() {
			if (this.info.lifeLabel && this.info.lifeLabel.length > 0) {
				return this.convertTreeDataToTreeArr(this.info.lifeLabel, 'labelName', 'labelId', 'parentId');
			} else {
				return [];
			}
		},

		standardMajorLabelInfo() {
			if (this.info.majorLabel && this.info.majorLabel.length > 0) {
				return this.convertTreeDataToTreeArr(this.info.majorLabel, 'labelName', 'labelId', 'parentId');
			} else {
				return [];
			}
		},
		//判断是否是主文件
		isMainFile() {
			/**
			 * 判断标准是否为主文件的逻辑：
			 * 1. 首先检查纸质版商品列表中是否有isMain=1的商品
			 * 2. 如果没有，再检查数字版商品列表中是否有isMain=1的商品
			 * 3. 如果还没有，最后检查JSON版商品列表中是否有isMain=1的商品
			 * 4. 如果都没有找到，则该标准为辅文件
			 *
			 * @returns {boolean} true表示是主文件，false表示是辅文件
			 */

			// 检查纸质版商品列表
			if (this.info.paperStandardProduct && this.info.paperStandardProduct.length > 0) {
				const hasMainPaper = this.info.paperStandardProduct.some(item => item.isMain == 1);
				if (hasMainPaper) {
					// 找到主文件商品信息
					this.mainFile = this.info.paperStandardProduct.find(item => item.isMain == 1);
					return true;
				}
			}

			// 检查数字版商品列表
			if (this.info.digitStandardProduct && this.info.digitStandardProduct.length > 0) {
				const hasMainDigital = this.info.digitStandardProduct.some(item => item.isMain == 1);
				if (hasMainDigital) {
					// 找到主文件商品信息
					this.mainFile = this.info.digitStandardProduct.find(item => item.isMain == 1);
					return true;
				}
			}

			// 检查JSON版商品列表
			if (this.info.jsonStandardProduct && this.info.jsonStandardProduct.length > 0) {
				const hasMainJson = this.info.jsonStandardProduct.some(item => item.isMain == 1);
				if (hasMainJson) {
					// 找到主文件商品信息
					this.mainFile = this.info.jsonStandardProduct.find(item => item.isMain == 1);
					return true;
				}
			}

			// 如果都没有找到主文件，返回false（辅文件）
			return false;
		},
		...mapGetters('User', ['uisLogin'])
	},
	methods: {
	

		getLifeName(lifeId) {
			if (!lifeId || !this.lifeList || !this.lifeList.length) return '';
			const found = this.lifeList.find(item => item.id === lifeId);
			return found ? found.lifeName : '';
		},

		getStandardTypeName(standardType) {
			if (standardType === undefined || standardType === null || !this.standardTypeList || !this.standardTypeList.length) return '';
			const found = this.standardTypeList.find(item => item.id === standardType);
			return found ? found.typeName : '';
		},

		getLifeTagType(lifeId) {
			if (!lifeId || !this.lifeList || !this.lifeList.length) return 'info';
			const found = this.lifeList.find(item => item.id === lifeId);
			if (!found) return 'info';
			const lifeNameLower = found.lifeName.toLowerCase();

			if (lifeNameLower.includes('现行') || lifeNameLower.includes('有效')) {
				return 'success'; // 绿色
			} else if (lifeNameLower.includes('征求意见稿') || lifeNameLower.includes('征求意见')) {
				return 'warning'; // 黄色
			} else if (lifeNameLower.includes('即将实施') || lifeNameLower.includes('即将生效')) {
				return 'primary'; // 蓝色
			}
			return 'danger'; // 红色
		},
		// 获取节点标题（处理null情况）
		getNodeTitle(data, node) {
			const number = data?.number;
			const label = node?.label;

			if (number && label) {
				return `${number}-${label}`;
			} else if (number) {
				return String(number);
			} else if (label) {
				return label;
			} else {
				return '未命名';
			}
		},

		// 获取节点显示文本（处理null情况）
		getNodeDisplayText(data, node) {
			const number = data?.number;
			const label = node?.label;

			if (number && label) {
				return `${number}-${label}`;
			} else if (number) {
				return String(number);
			} else if (label) {
				return label;
			} else {
				return '未命名';
			}
		},

		handleClick(id) {
			const targetRoute = this.$router.resolve({
				path: '/StandardsDet',
				query: { id }
			});
			window.open(targetRoute.href, '_blank');
		},

		//自动滚动时间轴到最右侧
		scrollTimelineToEnd() {
			this.$nextTick(() => {
				setTimeout(() => {
					const timelineElement = this.$refs.timeline?.$el;
					if (timelineElement) {
						// 获取时间轴的滚动容器
						const scrollContainer = timelineElement.querySelector('.el-timeline') || timelineElement;
						if (scrollContainer && scrollContainer.scrollWidth > scrollContainer.clientWidth) {
							this.performScrollToEnd(scrollContainer);
						}
					}
				}, 100); // 延迟100ms确保DOM完全渲染
			});
		},

		//执行滚动到最右侧
		performScrollToEnd(scrollContainer) {
			const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
			if (maxScrollLeft <= 0) return;

			// 检测浏览器是否支持平滑滚动
			if ('scrollTo' in scrollContainer && typeof scrollContainer.scrollTo === 'function') {
				try {
					scrollContainer.scrollTo({
						left: scrollContainer.scrollWidth,
						behavior: 'smooth'
					});
				} catch (error) {
					// 降级处理
					this.animateScrollFallback(scrollContainer, maxScrollLeft);
				}
			} else {
				// 浏览器不支持scrollTo，使用降级方案
				this.animateScrollFallback(scrollContainer, maxScrollLeft);
			}
		},

		//平滑滚动降级方案
		animateScrollFallback(scrollContainer, targetScrollLeft) {
			const startScrollLeft = scrollContainer.scrollLeft;
			const distance = targetScrollLeft - startScrollLeft;
			const duration = 500; // 动画持续时间（毫秒）
			const startTime = performance.now();

			const animate = currentTime => {
				const elapsed = currentTime - startTime;
				const progress = Math.min(elapsed / duration, 1);

				// 使用缓动函数
				const easeProgress = this.easeInOutCubic(progress);
				const currentScrollLeft = startScrollLeft + distance * easeProgress;

				scrollContainer.scrollLeft = currentScrollLeft;

				if (progress < 1) {
					requestAnimationFrame(animate);
				}
			};

			requestAnimationFrame(animate);
		},

		//缓动函数 - 三次贝塞尔曲线
		easeInOutCubic(t) {
			return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
		},

		//获取标准历史节点信息
		async getStandardHistoryDet() {
			const res = await getStandardHistoryDet(this.$route.query.id);
			if (res && res.data) {
				const data = res.data;
				data.forEach(item => {
					//获取T前面的时间
					item.historyDate = item.historyDate ? item.historyDate.split('T')[0] : '';
				});
				this.standardHistoryList = data;
				// 数据加载完成后，自动滚动到时间轴最右侧
				this.$nextTick(() => {
					this.scrollTimelineToEnd();
				});
			} else {
				this.standardHistoryList = [];
			}
		},

		//获取引用文件
		async getStandardReferenceFiles() {
			const res = await getQuoteStandardDet(this.$route.query.id);
			if (res && res.data) {
				this.referenceFiles = res.data;
			} else {
				this.referenceFiles = [];
			}
		},

		//获取采用文件
		async getStandardAdoptFiles() {
			const res = await getAdoptStandardDet(this.$route.query.id);
			if (res && res.data) {
				this.adoptFiles = res.data;
			} else {
				this.adoptFiles = [];
			}
		},

		//获取替代标准信息
		async getStandardReplaceFiles() {
			const res = await getReplaceStandardDet(this.$route.query.id);
			if (res && res.data) {
				this.replaceFiles = res.data;
			} else {
				this.replaceFiles = [];
			}
		},

		//获取被替代标准信息
		async getStandardReplacedFiles() {
			const res = await getReplacedStandardDet(this.$route.query.id);
			if (res && res.data) {
				this.replacedFiles = res.data;
			} else {
				this.replacedFiles = [];
			}
		},

		//获取标准明细信息

		//alternativeFiles

		...mapActions('Settings', ['setLoginShow']),
		//收藏标准
		postMemberBookCollectCancel() {
			getStandardDetRemoveCollect(this.info.id).then(res => {
				if (res.code == 200) {
					TMessage.success('取消收藏成功！');
					this.$emit('updateCollect');
				} else {
					TMessage.error('取消收藏失败！');
				}
			});
		},

		postMemberBookCollectConfirm() {
			postMemberBookCollect({
				typeId: 1,
				bookId: this.info.id
			}).then(res => {
				if (res.code == 200) {
					TMessage.success('收藏成功！');
					this.$emit('updateCollect');
				} else {
					TMessage.error('收藏失败！');
				}
			});
		},

		// 将树形数据转换为路径数组格式
		convertTreeDataToTreeArr(treeData, name, id, parentId) {
			if (!treeData || treeData.length === 0) return [];

			// 创建id到节点的映射
			const categoryMap = {};
			treeData.forEach(item => {
				categoryMap[item[id]] = item;
			});

			// 构建完整路径
			const result = [];
			treeData.forEach(item => {
				// 只处理叶子节点（没有子节点的节点）
				const hasChildren = treeData.some(node => node[parentId] === item[id]);
				if (!hasChildren) {
					const path = this.buildCategoryPath(item, categoryMap, name, id, parentId);
					result.push({
						[name]: path,
						[id]: item[id]
					});
				}
			});

			return result;
		},

		// 构建分类路径
		buildCategoryPath(node, categoryMap, name, id, parentId) {
			const path = [];
			let current = node;

			// 向上追溯直到根节点
			while (current) {
				path.unshift(current[name]);
				current = categoryMap[current[parentId]];
			}

			return path.join('>');
		},

		//收藏标准
		handleCollect() {
			if (!this.uisLogin) {
				this.setLoginShow(true);
				// const targetRoute = this.$router.resolve({
				// 	path: '/login'
				// });
				// window.open(targetRoute.href, '_blank');
			} else {
				if (this.info.isCollect) {
					this.postMemberBookCollectCancel();
				} else {
					this.postMemberBookCollectConfirm();
				}
			}
		},

		//获取目录数据
		async getFilesDocmentCatalogDet() {
			const params = {
				docmentId: this.$route.query.id,
				level: 3
			};
			const res = await getFilesDocmentCatalogDet(params);
			let treeData = res.data;

			// 递归处理树结构多层的标题，渲染LaTeX公式
			const processTreeData = items => {
				return items
					.map(item => {
						// 处理当前节点的标题
						if (item.title) {
							item.title = EReg.renderedFormula(EReg.removeNewlinesInLatexFormulas(item.title));
						}
						// 递归处理子节点
						if (item.children && item.children.length > 0) {
							item.children = processTreeData(item.children);
						}
						return item;
					})
					// 没有 number 也没有 label(title) 的节点：从树中移除
					.filter(item => item.number || item.title);
			};

			// 处理整个树结构
			this.treeData = processTreeData(treeData);
		},

		// 递归收集所有节点 ID（确保无遗漏）
		collectAllNodeIds(nodes, ids = []) {
			if (!nodes || nodes.length === 0) return ids;
			nodes.forEach(node => {
				ids.push(node.clauseId);
				if (node.children && node.children.length > 0) {
					this.collectAllNodeIds(node.children, ids);
				}
			});
			return ids;
		},

		//切换目录展开状态
		toggleCatalog() {
			this.treeKey += 1;
			if (this.expandedKeys.length > 0) {
				this.expandedKeys = [];
			} else {
				this.expandedKeys = this.collectAllNodeIds(this.treeData);
			}
		},

		//获取目录
		getBookcatalog() {
			const id = this.$route.query.id;
			this.loading = true;
			bookcatalog(id).then(res => {
				this.gmulu = res.data;
				this.loading = false;
			});
		},
		//获取相关讨论
		getCommunityList() {
			this.ajax_data_com.docmentId = this.$route.query.id;
			getCommunityList(this.ajax_data_com).then(res => {
				this.commList = res.rows;
				this.ajax_data_com.total = parseInt(res.total);
			});
		},
		handleLinktoComm() {
			this.$router.push({ path: '/community' });
		},

		openReadMore() {
			this.isCommentOpen = true;
		},

		// 分页
		onPage(page) {
			this.ajax_data_com.pageNum = page;
			this.getCommunityList();
			this.scrollToCommentList();
		},

		// 滚动到评论列表顶部
		scrollToCommentList() {
			this.$nextTick(() => {
				const element = document.querySelector('.goods-comment');
				if (element) {
					const elementRect = element.getBoundingClientRect();
					const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
					const targetPosition = elementRect.top + scrollTop - 90;
					window.scrollTo({
						top: targetPosition,
						behavior: 'smooth'
					});
				}
			});
		}
	},
	created() {
		this.getFilesDocmentCatalogDet();
		this.getStandardHistoryDet();
		this.getStandardReferenceFiles();
		this.getStandardAdoptFiles();
		this.getStandardReplaceFiles();
		this.getStandardReplacedFiles();
	}
};
</script>

<style lang="less" scoped>
.agency-item {
	margin-bottom: 12px;
	padding-bottom: 4px;
	border-bottom: 1px dashed #e5e5e5;
	.agency-title {
		font-weight: 500;
		margin: 0;
		font-size: 13px;
		color: #3d3d3d;
		margin-left: 6px;
		//超出部分显示...
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	label {
		font-size: 13px;
	}
}

.isLink {
	color: #1474e2;
	cursor: pointer;
	transition: all 0.3s ease-in-out;
	.agency-title {
		color: #1474e2;
	}
}

.isLink:hover {
	.agency-title {
		color: #409eff;
		transition: all 0.3s ease-in-out;
	}
}

.icon-collect-on {
	font-size: 22px !important;
	cursor: pointer;
	color: #e6a23c;
}
.icon-collect-off {
	font-size: 22px !important;
	cursor: pointer;
	color: #838a96;
}
.timeline {
	display: flex;
	width: 86%;
	// min-height: 142px;
	margin-bottom: 20px;
	// margin-left: -60px;
	margin-top: 30px;
	overflow-x: auto;
	overflow-y: hidden;
	// scroll-behavior: smooth; // 添加平滑滚动效果
	padding-left: 130px;
	scrollbar-width: thin; // Firefox 滚动条样式

	// Webkit 浏览器滚动条样式
	&::-webkit-scrollbar {
		height: 6px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 3px;
	}

	&::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 3px;

		&:hover {
			background: #a8a8a8;
		}
	}

	.lineitem {
		// transform: translateX(50%);
		// width: 25%;
		min-width: 200px;
		// transition: transform 0.3s ease; // 添加过渡动画

		&:hover {
			// transform: translateX(50%) scale(1.02); // 悬停时轻微放大
		}
	}
}

.tree-node-content {
	min-width: 0;
}

::v-deep .el-timeline-item__tail {
	border-left: none;
	border-top: 2px solid #e4e7ed;
	width: 100%;
	position: absolute;
	top: 6px;
}

::v-deep .el-timeline-item__wrapper {
	padding-left: 0;
	// position: absolute;
	top: 20px;
	transform: translateX(-50%);
	text-align: center;
}

::v-deep .el-timeline-item__timestamp {
	font-size: 14px;
}
.clearfix:before,
.clearfix:after {
	display: table;
	content: '';
}
.clearfix:after {
	clear: both;
}
.goods-item {
	margin-bottom: 30px;
	background-color: #ffffff;
	box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
	border-radius: 15px;
	color: #333333;
	.tags {
		flex: 1;
		min-width: 0;
		align-items: baseline;
	}
	h3 {
		margin: 0 0 15px;
		font-weight: 400;
		font-size: 24px;
	}
	h4 {
		margin: 0 0 15px;
		font-weight: 400;
		font-size: 18px;
	}
	p {
		font-size: 14px;
		color: #686f83;
		text-indent: 2em;
		line-height: 1.8;
		margin: 0 0 10px;
	}
	.ccard {
		margin-bottom: 10px;
		padding: 10px;
		background-color: #ffffff;
		box-shadow: 0px 0px 10px 0px rgba(227, 238, 255, 0.8);
		border-radius: 3px;
	}
	.pagebox {
		display: none;
	}
	.pagebox.pageopened {
		display: block;
	}
	.clist .ccard {
		display: none;
	}
	.clist .ccard.isopened {
		display: block;
	}
	.c-content {
		font-size: 14px;
		color: #686f83;
	}
	.c-foot {
		margin-top: 20px;
		font-size: 14px;
		color: #838a96;
		span + span {
			margin-right: 20px;
		}
	}
	.card-foot {
		margin-top: 20px;
	}
}
.el-tag {
	border-radius: 12px;
	font-size: 12px;
	padding: 0 12px;
	height: 20px;
	line-height: 18px;
	text-align: center;
}
.el-tag.el-tag--light {
	// color: #1474e2;
	// background-color: #e3eeff;
}
// .el-tag.el-tag--danger {
// 	color: #ec2b2d;
// 	background-color: #fef2f2;
// }
// .el-tag.el-tag--success {
// 	color: #67c23a;
// 	background-color: #f0f9eb;
// }
// /deep/ .el-tag.el-tag--warning {
// 	color: #a61fc8;
// 	background-color: #f7eeff;
// }
.el-tag.life-tag {
	border-radius: 20px;
	padding: 0px 20px;
	border: none;
	line-height: 24px;
	height: 24px;
}
// .life-tag.el-tag--warning {
// 	background-color: #f56c6c;
// 	border-color: #f56c6c;
// 	color: #fff;
// }
.infobox {
	margin-top: 30px;
	font-size: 13px;
	// color: #333333;
	color: #3d3d3d;
	overflow: hidden;
	dl {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		float: left;
		width: 50%;
		margin: 0 0 14px;
		box-sizing: border-box;
	}
	dl:nth-child(odd) {
		padding-right: 40px;
	}
	dt {
		width: 108px;
		color: #3d3d3d;
	}
	dd {
		margin: 0;
		font-weight: 500;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		flex: 1;
	}
}
/deep/ .el-avatar {
	margin-right: 10px;
}
.nullcolor {
	color: #afb1b5;
}

.view-box {
	margin-left: 20px;
	color: #888888;
	font-size: 14px;
	flex-wrap: wrap;
	gap: 10px;
	span + span {
		// margin-left: 25px;
	}
	i {
		margin-right: 5px;
		font-size: 16px;
	}
	em {
		font-style: normal;
	}
}

.goos-summary {
	font-size: 14px;
	// color: #686f83;
	color: #303133;
	line-height: 1.8;
	margin: 0 0 10px;
}

.aside-item {
	// display: flex;
	height: 24px;
	cursor: pointer;
	border-radius: 12px;
	padding: 8px 6px 8px 0px;
	font-size: 14px;
	line-height: 24px;
	color: #444;
	//超过显示省略号
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
//媒体查询-pad
@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
	.infobox {
		dl {
			width: 100%;
		}
	}
	.el-col-24 {
		width: auto;
	}
}

.catalog-collapsed {
	/* 只在内容超过600px时才显示滚动条 */
	max-height: 600px;
	overflow-y: auto;
	scrollbar-width: thin;

	// Webkit 浏览器滚动条样式
	&::-webkit-scrollbar {
		height: 6px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 3px;
	}

	&::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 3px;

		&:hover {
			background: #a8a8a8;
		}
	}
}
</style>
